import { footer_library } from "../metadata/footer_metadata";
import { hero_library } from "../metadata/hero_metadata";
import { navbar_library } from "../metadata/navbar_metadata";

export const libraries = {
  footer: footer_library,
  hero: hero_library,
  navbar: navbar_library
};
